import config from './config';
import { IConfig } from './IConfig';

export type { IConfig };
export default config;
